import { TranslationType } from './TranslationContext';

export const en: TranslationType = {
  header: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    contact: 'Contact',
    language: 'English',
    selectLanguage: 'Select Language',
    scheduleConsultation: 'Schedule a Consultation',
    allServices: 'All Services',
    monthlyBookkeeping: 'Digital Monthly Bookkeeping',
    taxPreparation: 'Business tax services',
    financialPlanning: 'Financial Planning',
    businessConsulting: 'Strategic Support'
  },
  hero: {
    tagline: "Hey there! We're the Algebra Solution Financières",
    title: {
      part1: '',
      highlight1: 'Expert',
      part2: ' Accounting Solutions for ',
      highlight2: 'Your Business'
    },
    description: 'Professional accounting services tailored to help your business grow.',
    consultation: "Get a consultation today, it's free!",
    contactUs: 'Contact us'
  },
  about: {
    banner: {
      title: "We're here to guarantee you success",
      subtitle: "We're dedicated to your success, providing expert accounting services and insights to help you achieve your business goals.",
      chips: "About Us"
    },
    story: {
      title: "Built to Empower Growing Businesses Since 2020",
      description: "Founded in 2024, Algebra Solutions Financières makes professional accounting services accessible to growing businesses. Our founder, Oussama Hentabli, CPA, brings valuable experience from Big 4 accounting firms, small practices, and large corporations. This diverse background enables us to support businesses effectively, combining the rigor of large firms with the personalized approach of boutique services.",
      chips: "Our Story",
      button: "Book an Appointment"
    },
    mission: {
      title: "Expert financial guidance for business growth.",
      description: "\"Our mission is to empower businesses with clear financial insights and expert accounting solutions, enabling them to make confident decisions and achieve sustainable growth.\"",
      chips: "Our Mission",
      button: "Book an Appointment"
    },
    values: {
      title: "The Values That Shape Us",
      subtitle: "Our values of transparency, innovation, and client-centricity drive everything we do, ensuring we deliver exceptional service and build lasting partnerships.",
      chips: "Our Values",
      value1: {
        title: "Excellence in service delivery",
        description: "We provide tailored accounting solutions with precision and a focus on client success—ensuring every interaction adds value."
      },
      value2: {
        title: "Transparent communication",
        description: "We value open and clear communication. Keeping clients informed builds trust and ensures confident decisions."
      },
      value3: {
        title: "Continuous innovation",
        description: "We embrace new ideas and technologies. Our focus on innovation drives us to improve services and deliver solutions for our clients' needs."
      },
      value4: {
        title: "Client-focused approach",
        description: "We prioritize our clients' needs, offering personalized solutions that drive success and foster long-term relationships."
      }
    }
  },
  contact: {
    banner: {
      title: "We're here to help",
      subtitle: "Reach out to us directly using the contact information below or schedule a meeting using our online booking system.",
      chips: "Contact Us"
    },
    info: {
      title: "Get in Touch",
      subtitle: "Contact our accounting team directly or use our convenient scheduling tool to book a consultation with one of our experts.",
      chips: "Contact Us",
      phone: {
        label: "Phone Call",
        value: "(514) 508-5552"
      },
      email: {
        label: "Email Address",
        value: "info@algebrasolution.ca"
      },
      location: {
        label: "Location",
        value: "6500 Trans-Canada Hwy, Ste 400, Pointe-Claire, QC H9R 0A5"
      },
      hours: {
        label: "Office Hours",
        weekdays: "Monday – Friday: 9:00 AM – 5:00 PM",
        saturday: "Saturday: By appointment",
        sunday: "Sunday: Closed"
      }
    },
    form: {
      title: "Schedule an Appointment"
    }
  },
  services: {
    banner: {
      title: "Your Finances, Our Expertise",
      subtitle: "Explore our comprehensive range of services designed to help your business thrive.",
      chips: "Our Services",
      button: "Schedule a Free Consultation"
    },
    monthlyBookkeeping: {
      title: "Digital Monthly Bookkeeping",
      description: "Comprehensive bookkeeping services to keep your finances organized and up-to-date. We handle accounts payable, accounts receivable, reconciliations, and monthly financial statements.",
      chips: "Digital Monthly Bookkeeping",
      button: "See Details",
      benefits: {
        title: "Key Benefits:",
        points: [
          "Real-time record accuracy",
          "Save hours each month",
          "Personalized reporting"
        ]
      }
    },
    taxPreparation: {
      title: "Business tax services",
      description: "Expert tax preparation services for businesses and individuals. We ensure accurate filing while maximizing deductions and credits available to you.",
      chips: "Business tax services",
      button: "See Details",
      benefits: {
        title: "Key Benefits:",
        points: [
          "Maximize deductions",
          "Minimize tax liability",
          "Up-to-date with latest tax laws"
        ]
      }
    },
    financialPlanning: {
      title: "Financial Planning",
      description: "Strategic financial planning to help you achieve your business goals. We analyze your current position and develop customized strategies for growth.",
      chips: "Financial Planning",
      button: "See Details",
      benefits: {
        title: "Key Benefits:",
        points: [
          "Custom growth strategies",
          "Long-term financial forecasting",
          "Expert guidance at every step"
        ]
      }
    },
    businessConsulting: {
      title: "Strategic Support",
      description: "Expert guidance to optimize your business strategy and growth. We help you make informed decisions, identify opportunities, and navigate challenges with confidence.",
      chips: "Strategic Support",
      button: "View details",
      benefits: {
        title: "Key benefits:",
        points: [
          "Personalized strategic roadmaps",
          "Expert business insights",
          "Data-driven decision support"
        ]
      }
    }
  },
  monthlyBookkeeping: {
    banner: {
      title: "Digital Monthly Bookkeeping",
      subtitle: "Keep your finances organized and stress-free with our comprehensive bookkeeping services. We handle the numbers so you can focus on growing your business.",
      chips: "Our Services",
      button: "Schedule a Free Consultation"
    },
    included: {
      title: "What's Included",
      subtitle: "Our monthly bookkeeping service covers every critical aspect of your financial operations:",
      chips: "What's Included",
      sections: {
        accountsPayable: {
          title: "Accounts Payable & Receivable",
          description: "We track all incoming and outgoing payments, provide timely invoicing, and follow up on overdue accounts to maintain healthy cash flow and strong vendor relationships."
        },
        reconciliations: {
          title: "Bank & Credit Card Reconciliations",
          description: "We compare your internal records with bank statements to identify discrepancies, detect errors or fraud early, and ensure your financial data is accurate."
        },
        statements: {
          title: "Monthly Financial Statements",
          description: "We prepare balance sheets, income statements, and cash flow reports with professional analysis to help you understand trends and make informed business decisions."
        },
        categorization: {
          title: "Transaction Categorization",
          description: "We classify each transaction according to accounting principles and your business needs, providing insights into spending patterns and potential tax deductions."
        }
      }
    },
    benefits: {
      title: "Key Benefits",
      chips: "Key Benefits",
      sections: {
        time: {
          title: "Save Time",
          description: "We handle all financial record-keeping so you can focus on strategic initiatives and core business activities that drive growth and profitability."
        },
        compliance: {
          title: "Stay Compliant",
          description: "Our meticulous approach ensures your business remains compliant with all regulatory requirements, reducing stress and minimizing potential penalties."
        },
        visibility: {
          title: "Real-Time Visibility",
          description: "Access your financial data through secure, cloud-based systems to monitor cash flow, track expenses, and make informed decisions quickly."
        }
      },
      button: "Schedule Now"
    },
    faq: {
      title: "Frequently Asked Questions",
      chips: "FAQ's",
      questions: {
        data: {
          question: "How do I send my financial data?",
          answer: "We offer a secure client portal for document uploads, direct integration with your accounting software, or read-only access to your accounts. All transfers are protected by enterprise-grade encryption."
        },
        system: {
          question: "Can you work with my existing system?",
          answer: "Yes! We're experienced with all major accounting platforms including QuickBooks, Xero, Sage, and FreshBooks. We can integrate with your current system or help implement a new solution."
        },
        commitment: {
          question: "Do I need to commit long-term?",
          answer: "We offer flexible month-to-month services without requiring long-term contracts. You can adjust as your business needs change, though many clients continue with us after seeing the benefits."
        }
      }
    }
  },
  taxPreparation: {
    banner: {
      title: "Business tax services",
      subtitle: "Stress-free tax services for businesses and individuals. We handle the details so you can focus on what matters most.",
      chips: "Our Services",
      button: "Schedule a Free Consultation"
    },
    included: {
      title: "What's Included",
      subtitle: "Our tax preparation service covers every critical aspect of your tax filing needs:",
      chips: "What's Included",
      sections: {
        returns: {
          title: "Business & Personal Tax Returns",
          description: "Comprehensive preparation of all required tax returns for your business and personal finances. We handle corporations, partnerships, sole proprietorships, and individual returns."
        },
        optimization: {
          title: "Deduction & Credit Optimization",
          description: "Strategic analysis of your financial situation to identify all eligible deductions and credits. We ensure you're taking advantage of every tax-saving opportunity available."
        },
        support: {
          title: "Year-Round Tax Support",
          description: "Ongoing assistance with tax-related questions and planning throughout the year, not just during tax season. We provide proactive advice on tax implications for business decisions."
        },
        documentation: {
          title: "Audit-Ready Documentation",
          description: "Stay prepared with properly organized and compliant records. We help you maintain thorough documentation that meets regulatory requirements and provides peace of mind."
        },
        financialStatements: {
          title: "Financial Statement Production (Compilation Engagement)",
          description: "Professional preparation of financial statements under a compilation engagement, compliant with applicable accounting standards. We provide reliable financial reports that clearly present your business's financial position."
        }
      }
    },
    benefits: {
      title: "Key Benefits",
      chips: "Key Benefits",
      sections: {
        refunds: {
          title: "Maximize Your Refunds",
          description: "We look at your full financial picture to uncover savings opportunities and ensure you receive every dollar you're entitled to under tax law."
        },
        mistakes: {
          title: "Avoid Costly Mistakes",
          description: "Our experts stay up to date on tax laws so you don't have to. We help you navigate complex regulations and prevent errors that could lead to penalties or audits."
        },
        peace: {
          title: "Peace of Mind",
          description: "With everything handled professionally, you can feel confident at tax time. Our thorough approach ensures compliance while maximizing your financial benefits."
        }
      },
      button: "Schedule Now"
    },
    faq: {
      title: "Frequently Asked Questions",
      chips: "FAQ's",
      questions: {
        behind: {
          question: "Can you help if I'm behind on my taxes?",
          answer: "Yes, we assist with back filings and negotiating payment arrangements if needed. Our team has experience working with clients who need to catch up on multiple years of tax filings."
        },
        selfEmployed: {
          question: "Do you work with self-employed individuals and freelancers?",
          answer: "Absolutely! We specialize in helping self-employed professionals navigate their unique tax situations, from tracking business expenses to maximizing home office deductions."
        },
        documents: {
          question: "What documents do I need to get started?",
          answer: "For personal returns: income statements, expense records, and last year's return. Business clients: profit/loss statements, balance sheets, and payroll records. We'll provide a customized checklist during consultation."
        }
      }
    }
  },
  financialPlanning: {
    banner: {
      title: "Financial Planning",
      subtitle: "Strategic financial guidance tailored to your business goals. We help you build a roadmap for growth, stability, and long-term success.",
      chips: "Our Services",
      button: "Schedule a Free Consultation"
    },
    included: {
      title: "What's Included",
      subtitle: "Our financial planning service covers every critical aspect of your business growth strategy:",
      chips: "What's Included",
      sections: {
        assessment: {
          title: "Current Financial Assessment",
          description: "Comprehensive analysis of your current financial position, including assets, liabilities, cash flow patterns, and profitability metrics. We establish a clear baseline to measure progress."
        },
        strategy: {
          title: "Goal-Oriented Strategy Development",
          description: "Collaborative creation of financial strategies aligned with your specific business objectives. We translate your vision into actionable financial plans with clear milestones."
        },
        cashFlow: {
          title: "Cash Flow & Budget Planning",
          description: "Development of robust cash flow management systems and realistic budgets that support your business operations and growth plans. We help you anticipate challenges and maintain stability."
        },
        growth: {
          title: "Growth & Investment Planning",
          description: "Make informed decisions about expansion, hiring, and capital investments. Our analysis includes detailed ROI projections, financing options, and risk evaluation."
        }
      }
    },
    benefits: {
      title: "Key Benefits",
      chips: "Key Benefits",
      sections: {
        decisions: {
          title: "Make Informed Decisions",
          description: "Understand your numbers and what they mean for your business trajectory. Our clear financial insights empower you to make strategic choices with confidence, based on data rather than guesswork."
        },
        growth: {
          title: "Achieve Sustainable Growth",
          description: "Plan for the future with strategies designed to support long-term stability. We help you balance ambitious growth targets with prudent financial management."
        },
        profitability: {
          title: "Maximize Profitability",
          description: "Identify areas for cost reduction, revenue improvement, and investment opportunities. Our approach helps optimize your financial performance while maintaining quality."
        }
      },
      button: "Schedule Now"
    },
    faq: {
      title: "Frequently Asked Questions",
      chips: "FAQ's",
      questions: {
        who: {
          question: "Who is financial planning best for?",
          answer: "Any business looking to grow strategically, improve cash flow, or prepare for major changes. It's particularly valuable for businesses experiencing rapid growth, considering expansion, or facing cash flow challenges."
        },
        size: {
          question: "Do I need to have a large business?",
          answer: "Not at all. We work with businesses of all sizes, from solopreneurs to established companies. Smaller businesses often benefit significantly from professional financial planning to establish strong foundations."
        },
        implementation: {
          question: "Will you help with implementation?",
          answer: "Absolutely. We don't just deliver a plan and leave you to figure it out. Our service includes implementation support, regular progress reviews, and adjustments as needed."
        }
      }
    }
  },
businessConsulting: {
  banner: {
    title: "Strategic Support",
    subtitle: "Expert guidance to optimize your business strategy and growth. Whether you're navigating challenges or pursuing new opportunities, our strategic support helps you make informed decisions with confidence.",
    chips: "Our Services",
    button: "Schedule a Free Strategy Session"
  },
  included: {
    title: "What's Included",
    subtitle: "Our strategic support services are designed to provide you with expert guidance at every stage of your business journey — from strategic planning to execution and evaluation.",
    chips: "What's Included",
    sections: {
      startup: {
        title: "Strategy Development",
        description: "Collaborative creation of robust business strategies aligned with your vision and market opportunities. We help you establish clear objectives and actionable roadmaps."
      },
      financial: {
        title: "Performance Analysis",
        description: "In-depth evaluation of your business performance against strategic goals. We identify improvement areas and recommend strategic adjustments to enhance results."
      },
      cashFlow: {
        title: "Resource Optimization",
        description: "Strategic allocation of your business resources to maximize efficiency and support growth. We develop frameworks to ensure your investments yield optimal returns."
      },
      growth: {
        title: "Growth & Innovation Planning",
        description: "Forward-thinking approaches to business development and innovation. We help you identify new opportunities and create strategic implementation plans."
      }
    }
  },
  benefits: {
    title: "Key Benefits",
    chips: "Key Benefits",
    sections: {
      experience: {
        title: "Strategic Expertise",
        description: "We bring comprehensive strategic knowledge and real-world business insights. Our advisors provide valuable perspectives that help you navigate complex business challenges and identify growth opportunities."
      },
      roadmaps: {
        title: "Customized Approach",
        description: "Every business has unique needs and goals — our strategic support is tailored specifically to your situation. We develop personalized strategies that address your specific challenges and objectives."
      },
      decisions: {
        title: "Informed Decision-Making",
        description: "Make confident decisions backed by thorough analysis and strategic thinking. We provide clear frameworks and insights that empower you to make choices aligned with your long-term vision."
      }
    },
    button: "Schedule Now"
  },
  faq: {
    title: "Frequently Asked Questions",
    chips: "FAQ's",
    questions: {
      startup: {
        question: "How can strategic support benefit my business?",
        answer: "Strategic support provides your business with expert guidance for making informed decisions, identifying growth opportunities, optimizing operations, and developing long-term plans. It helps you navigate challenges and position your business for sustainable success."
      },
      industries: {
        question: "What types of businesses do you provide strategic support for?",
        answer: "We offer strategic support across diverse industries, including technology, professional services, retail, manufacturing, healthcare, and more. Our strategic expertise can be applied to businesses of all sizes and stages."
      },
      implementation: {
        question: "Do you assist with strategy implementation?",
        answer: "Yes, we provide both strategic planning and implementation support. We believe in creating practical strategies that can be effectively executed, and we partner with you throughout the implementation process to ensure success."
      }
    }
  }
},
  servicesWeOffer: {
    title: 'Services We Offer',
    subtitle: 'Comprehensive accounting solutions to help your business thrive',
    services: {
      bookkeeping: {
        title: 'Digital Monthly Bookkeeping',
        description: 'Accurate financial records and timely reporting to keep your business on track.'
      },
      taxPreparation: {
        title: 'Business tax services',
        description: 'Maximize deductions and ensure compliance with all tax regulations.'
      },
      financialPlanning: {
        title: 'Financial Planning',
        description: 'Strategic guidance to help you achieve your short and long-term business goals.'
      },
      businessConsulting: {
        title: 'Strategic Support',
        description: 'Personalized advice and support for the strategic development of your business.'
      }
    },
    viewAll: 'View All Services'
  },
  whatAlgebraCan: {
    benefits: 'Benefits',
    title: {
      part1: 'What ',
      highlight: 'Algebra',
      part2: ' can do'
    },
    description: 'Algebra is redefining the future of banking and finance. With years of industry experience, we combine precision, innovation, and personalized service to deliver unmatched financial clarity',
    points: {
      experience: 'Years of accounting expertise',
      dedicated: 'Dedicated personal accountant for every client',
      advanced: 'Advanced digital solutions for efficient service'
    }
  },
  testimonials: {
    title: 'What Our Clients Say',
    subtitle: 'Hear from businesses we\'ve helped succeed',
    testimonials: {
      client1: {
        quote: 'Algebra transformed our financial management. Their expertise helped us reduce costs and improve cash flow significantly.',
        name: 'Sarah Johnson',
        position: 'CEO, TechStart Inc.'
      },
      client2: {
        quote: 'The team at Algebra provided invaluable guidance during our expansion. Their financial planning made all the difference.',
        name: 'Michael Chen',
        position: 'Founder, GrowthPath Solutions'
      },
      client3: {
        quote: 'Working with Algebra has been a game-changer for our business. Their attention to detail and proactive approach is exceptional.',
        name: 'Emily Rodriguez',
        position: 'Director, Innovative Retail Group'
      }
    }
  },
  footer: {
    reliable: {
      title: {
        part1: '',
        highlight1: 'Reliable',
        part2: ' Accounting. ',
        highlight2: 'Remarkable'
      },
      description: 'From dedicated personal accountants to advanced digital tools, Algebra offers a seamless accounting experience that\'s built on trust, precision, and performance.',
      button: 'Schedule a Consultation'
    },
    about: 'We provide comprehensive accounting services to help businesses make informed financial decisions and achieve their goals',
    services: {
      title: 'Services',
      taxPlanning: 'Tax Planning',
      financialAnalysis: 'Financial Analysis',
      bookkeepingServices: 'Bookkeeping Services',
      businessConsulting: 'Strategic Support',
      strategicSupport : 'Strategic Support'
    },
    company: {
      title: 'Company',
      services: 'Services',
      aboutUs: 'About Us',
      project: 'Project',
      customer: 'Customer'
    },
    contact: {
      title: 'QUICK CONTACT',
      contactUs: 'Contact Us',
      termsOfService: 'Terms Of Service'
    },
    copyright: 'Copyright @ 2025 Algebra Solution Financières, All rights reserved'
  }
};
